import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'beacon' })
export class BeaconPipe implements PipeTransform {

  transform(beacon: any): string {
    return `${beacon.markerId || '-'} (${beacon.deviceId || '-'})`
  }
}
